/**
 * 대시보드
 */

import { customAxios } from "./customAxios";


// /**
//  * 노선도
//  * @returns 
//  */
// export const getDashboardStations = async(query)=>{
//     const res = await customAxios.get('/api/dashboard/stations',{params : query});
//     //console.log(res);
//     if (res && res.data) {
//        //return Object.values(res.data);
//        return res.data;
//     }
//     return null;
// }

// export const getDashboardStationAlerts = async(query)=>{
//   const res = await customAxios.get('/api/dashboard/stationAlerts',{params : query});
//   // const res = await customAxios.get('/api/dashboard/stations:includingEquipmentFaultStatus',{params : query});
//   //console.log(res);
//   if (res && res.data) {
//      //return Object.values(res.data);
//      return res.data;
//   }
//   return null;
// }

/**
 * 상태현황
 * @returns 
 */
export const getDashboardCountGroupByStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment/by-status',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 상태현황(이하이-성)
 * @returns 
 */
export const getDashboardStatusByChinaRegionPivotByStatus = async()=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment/status/by-china-region/pivot');
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 등록현황(이하이)
 * @returns 
 */
export const getDashboardCountEquipmentSummary = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countEquipmentSummary',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 설비타입별 상태현황
 * @returns 
 */
export const getDashboardCountByCategoryAndEquipmentStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment/status/by-category/pivot',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 구역별 상태현황(메인대시보드)
 * @returns 
 */
export const getDashboardCountByZoneAndEquipmentStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment/status/by-zone/pivot',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 설비 운행 상태(운전/정지) 별 설비 건 수 현황(메인대시보드 등록설비)
 * @returns 
 */
export const getDashboardEquipmentCountGroupByOpStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment/by-op-status',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 설비 연관 구역 수 현황(메인대시보드 구역수)
 * @returns 
 */
export const getDashboardZoneCountGroupByRelatedToEquipment = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment-zone/count/related-to-equipment',{params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

export const getDashboardCountGroupByMaxGrade = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByMaxGrade',{params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
* 설비별 경보현황(호선별 선그래프)-월별
* @returns 
*/
export const getDashboardCountEquipmentAlertGroupByMonth = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countEquipmentAlertGroupByMonth', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
* 설비별 경보현황(호선별 선그래프)-월별,설비대분류별
* @returns 
*/
export const getDashboardCountEquipmentAlertGroupByMonthAndCategory1 = async(query)=>{
  const res = await customAxios.get('/api/dashboard/stats/equipment-alert/monthly-by-category-1', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}


/**
* 설비별 경보현황(호선별 선그래프)-월별,설비타입별
* @returns 
*/
export const getDashboardCountEquipmentAlertGroupByMonthAndCategory3 = async(query)=>{
  const res = await customAxios.get('/api/dashboard/stats/equipment-alert/monthly-by-category-3', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
* 설비별 경보현황(호선별 선그래프)-월별,설비별
* @returns 
*/
export const getDashboardCountEquipmentAlertGroupByMonthAndEquipment = async(query)=>{
  const res = await customAxios.get('/api/dashboard/stats/equipment-alert/monthly-by-equipment', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비대분류별 경보현황(호선별 원그래프)
 * @returns 
 */
export const getDashboardCountEquipmentAlertGroupByEquipmentCtgr1 = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countEquipmentAlertGroupByEquipmentCtgr1', {params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

// /**
//  * 파트별 상태 현황
//  * @returns 
//  */
// export const getDashboardCountGroupByStatusAndWorkingPart = async()=>{
//     const res = await customAxios.get('/api/dashboard/countGroupByStatusAndWorkingPart');
//     //console.log(res);
//     if (res && res.data) {
//        //return Object.values(res.data);
//        return res.data;
//     }
//     return null;
// }

// /**
//  * 역사별 상태 현황
//  * @returns 
//  */
// export const getDashboardCountGroupByStatusAndStation = async(query)=>{
//     const res = await customAxios.get('/api/dashboard/countGroupByStatusAndStation',{params : query});
//     //console.log(res);
//     if (res && res.data) {
//        //return Object.values(res.data);
//        return res.data;
//     }
//     return null;
// }

/**
 * 후속조치별 건수 현황
 * @returns 
 */
export const getDashboardCountGroupByFollowActionType = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByFollowActionType',{params : query});
  //console.log(res);
  if (res && res.data) {
     //return Object.values(res.data);
     return res.data;
  }
  return null;
}

/**
 * 설비별 경보현황(호선별 원그래프)
 * @returns 
 */
export const getDashboardCountGroupByEquipmentCtgr = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByEquipmentCtgr', {params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 설비별 경보현황(호선별 선그래프)
 * @returns 
 */
export const getDashboardCountMonthlyGroupByEquipmentCtgr = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countMonthlyGroupByEquipmentCtgr', {params : query});
    //console.log(res);
    if (res && res.data) {
       //return Object.values(res.data);
       return res.data;
    }
    return null;
}

/**
 * 점검필요(경보발생) 설비 목록
 * @returns 
 */
export const getDashboardEquipmentAlertsByQuery = async(query)=>{
    const res = await customAxios.get('/api/dashboard/equipmentAlerts', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/********************************** 유지보수 **********************************/

// /**
//  * 유지보수 점검대상(파트별)
//  * @param {*} query 
//  * @returns 
//  */
// export const getDashboardCountGroupByMntStatusAndWorkingPart = async(query)=>{
//     const res = await customAxios.get('/api/dashboard/countGroupByMntStatusAndWorkingPart', {params : query});
//     //console.log(res);
//     if (res.data) {
//       return res.data;
//     }
//     return null;
// }

// export const getDashboardCountWorkItemsGroupByWorkingPart = async(query)=>{
//   const res = await customAxios.get('/api/dashboard/countWorkItemsGroupByWorkingPart', {params : query});
//   //console.log(res);
//   if (res.data) {
//     return res.data;
//   }
//   return null;
// }

// export const getDashboardCountEquipmentAlertDelayGroupByWorkingPart = async(query)=>{
//   const res = await customAxios.get('/api/dashboard/countEquipmentAlertDelayGroupByWorkingPart', {params : query});
//   //console.log(res);
//   if (res.data) {
//     return res.data;
//   }
//   return null;
// }

// /**
//  * 유지보수 점검대상(역사별)
//  * @param {*} query 
//  * @returns 
//  */
// export const getDashboardCountEquipmentAlertDelayGroupByStation = async(query)=>{
//     const res = await customAxios.get('/api/dashboard/countEquipmentAlertDelayGroupByStation', {params : query});
//     //console.log(res);
//     if (res.data) {
//       return res.data;
//     }
//     return null;
// }

// /**
//  * 유지보수 점검대상(역사별)
//  * @param {*} query 
//  * @returns 
//  */
// export const getDashboardCountGroupByMntStatusAndStation = async(query)=>{
//     const res = await customAxios.get('/api/dashboard/countGroupByMntStatusAndStation', {params : query});
//     //console.log(res);
//     if (res.data) {
//       return res.data;
//     }
//     return null;
// }

// export const getDashboardCountWorkItemsGroupByStation = async(query)=>{
//   const res = await customAxios.get('/api/dashboard/countWorkItemsGroupByStation', {params : query});
//   //console.log(res);
//   if (res.data) {
//     return res.data;
//   }
//   return null;
// }

/**
 * 유지보수 점검대상(역사의 경보상태별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByMntStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByMntStatus', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

export const getDashboardCountWorkItems = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countWorkItems', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

// /**
//  * 유지보수 점검내역(파트별)
//  * @param {*} query 
//  * @returns 
//  */
// export const getDashboardCountGroupByFllwActionTypeAndWorkingPart = async(query)=>{
//     const res = await customAxios.get('/api/dashboard/countGroupByFllwActionTypeAndWorkingPart', {params : query});
//     //console.log(res);
//     if (res.data) {
//       return res.data;
//     }
//     return null;
// }

// /**
//  * 유지보수 점검내역(역사별)
//  * @param {*} query 
//  * @returns 
//  */
// export const getDashboardCountGroupByFllwActionTypeAndStation = async(query)=>{
//     const res = await customAxios.get('/api/dashboard/countGroupByFllwActionTypeAndStation', {params : query});
//     //console.log(res);
//     if (res.data) {
//       return res.data;
//     }
//     return null;
// }

/**
 * 유지보수 점검내역(역사의 후속조치별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByFllwActionType = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByFllwActionType', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수 등록현황
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByCategory = async(query)=>{
    const res = await customAxios.get('/api/dashboard/countGroupByCategory', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 유지보수내역(역사의 유지보수 조치유형별)
 * @param {*} query 
 * @returns 
 */
export const getDashboardCountGroupByMntType = async(query)=>{
  const res = await customAxios.get('/api/dashboard/countGroupByMntType', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

// /**
//  * 유지보수내역(파트별)
//  * @param {*} query 
//  * @returns 
//  */
// export const getDashboardCountGroupByMntTypeAndWorkingPart = async(query)=>{
//   const res = await customAxios.get('/api/dashboard/countGroupByMntTypeAndWorkingPart', {params : query});
//   //console.log(res);
//   if (res.data) {
//     return res.data;
//   }
//   return null;
// }

// /**
// * 유지보수내역(역사별)
// * @param {*} query 
// * @returns 
// */
// export const getDashboardCountGroupByMntTypeAndStation = async(query)=>{
//   const res = await customAxios.get('/api/dashboard/countGroupByMntTypeAndStation', {params : query});
//   //console.log(res);
//   if (res.data) {
//     return res.data;
//   }
//   return null;
// }

/***************************************************************************/
/**
 * 메인 대시보드 설비 및 설비상태별 카운트
 * 2026.04.08
 * 
 * @param {*} query 
 * @returns 
 */
export const getDashboardStatsEquipmentCount = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment-count', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 메인 대시보드 전체 구역 마스터 구조 및 점유 통계 조회
 * 2026.04.09
 * 
 * @param {*} query 
 * @returns 
 */
export const getDashboardStatsEquipmentZoneStatus = async()=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment-zone-status');
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 메인 대시보드 월별 설비 경보 발생 통계조회(난퉁메인대시보드)
 * 2026.04.09
 * 
 * @param {*} query 
 * @returns 
 */
export const getDashboardStatsMonthlyEquipmentAlertCount = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/latest-12-months-equipment-alert-count', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}


/**
 * 메인 대시보드 월별 설비 경보 발생 통계조회(난퉁메인대시보드)
 * 2026.07.24 dh
 * 
 * @param {*} query 
 * @returns 
 */
export const getDashboardStatsEquipmentAlertCountByPeriodType = async(periodType='YEAR', query)=>{
    const res = await customAxios.get(`/api/dashboard/stats/equipment-alert-count/${periodType}`, {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}

/**
 * 서브 대시보드 설비목록
 * 2026.04.09
 * 
 * @param {*} query 
 * @returns 
 */
export const getDashboardStatsEquipmentStatus = async(query)=>{
    const res = await customAxios.get('/api/dashboard/stats/equipment-status', {params : query});
    //console.log(res);
    if (res.data) {
      return res.data;
    }
    return null;
}
